import { useEffect, useState } from "react";
import { authEventBus } from "../auth.events";

export function useTrackLoginEvents() {
  const [loginIntentRegistered, setLoginIntentRegistered] = useState(false);

  useEffect(() => {
    if (loginIntentRegistered) return;

    authEventBus.emitEvent("auth:login:intent");

    setLoginIntentRegistered(true);
  }, [loginIntentRegistered]);
}

export default useTrackLoginEvents;
